// Was sol das Mist Ding hier überhaupt?! das macht ja garnichts ausser aufklappen!!!11

// Wieso muss denn jemand der das benutzt selbst ie active klasse setzen und den body wieder zumachen? Oo


const CONSTANTS = {
    FILTER_VUE_CLASS: 'global-filter-list--vue',
    HEADER_CLASS: 'filter__head',
    BODY_CLASS: 'filter__body',
    FILTER_CLASS: 'filter'
};

let options = {
    headerClass: CONSTANTS.HEADER_CLASS,
    bodyClass: CONSTANTS.BODY_CLASS,
    filterClass: CONSTANTS.FILTER_CLASS,
};

const actions = {
    toggleBody: e => {
        let filterBody = e.currentTarget.nextElementSibling;

        if (filterBody.style.display === 'block') {
            filterBody.style.display = '';
        } else {
            filterBody.style.display = 'block';
        }
    },
};

const eventHandler = {
    click: (e) => {
        actions.toggleBody(e);
        const icon = e.currentTarget.querySelector('.icon--after');
        icon.classList.toggle('icon--arrow-down');
        icon.classList.toggle('icon--arrow-up');
    },
};

const dropdown = {
    init: (overwriteOptions) => {
        options = Object.assign(options, overwriteOptions);

        let filterHeaderElements = document.querySelectorAll(`*:not(.${options.filterVueClass}) > .${options.headerClass}`);
        filterHeaderElements.forEach(element => {
            element.addEventListener('click', eventHandler.click);
        });
    }
};

export { dropdown };
